import React from "react";
import DataIcon from "../../Common/svg/messages/data";

const EmptyList = () => {
  return (
    <div className="text-center d-flex flex-column justify-content-center align-items-center">
      <div
        style={{
          width: "64px",
          height: "64px",
          display:"flex",
          justifyContent: "center",
          alignItems: "center",
          background: " #FDEAE9",
          borderRadius:"50%"
        }}
      >
        <DataIcon />
      </div>
      <h4 className="font800">لا توجد بيانات</h4>
      <p className="desc">لم يتم تسجيل أي بيانات بعد.</p>
    </div>
  );
};

export default EmptyList;
